import * as React from 'react';
import { spaceS, spaceM, spaceXL } from '@xingternal/tokens';
import { IconArrowLeft, IconArrowRight } from '@xingternal/icons';
import { useWindowSize } from './hooks/use-window-size';
import { Item } from './item';
import * as Styled from './carousel.styles';
export const Carousel = ({ children, className, customScrollWidth, hideScrollbar, horizontalPadding, horizontalPaddingConfined, horizontalPaddingWide, itemMaxWidth, itemMinWidth, itemSnapPosition, itemSpacing = spaceM, itemSpacingConfined = spaceXL, itemSpacingWide, itemWidth = '80%', itemWidthConfined = '33%', itemWidthWide, onItemEnter, onNextClick, onPreviousClick, paddingBottom = spaceS, paddingBottomConfined, paddingBottomWide, paddingTop, paddingTopConfined, paddingTopWide, tabbable = false, verticalAlignment = 'stretch', ...props }) => {
    const size = useWindowSize();
    const carouselRef = React.createRef();
    const [carouselDimensions, setCarouselDimension] = React.useState({
        clientWidth: 0,
        scrollWidth: 0,
        scrollLeft: 0,
    });
    const itemProps = {
        horizontalPadding,
        horizontalPaddingConfined,
        horizontalPaddingWide,
        itemMaxWidth,
        itemMinWidth,
        itemSnapPosition,
        itemSpacing,
        itemSpacingConfined,
        itemSpacingWide,
        itemWidth,
        itemWidthConfined,
        itemWidthWide,
        lastItemSpace: horizontalPadding,
        lastItemSpaceConfined: horizontalPaddingConfined,
        lastItemSpaceWide: horizontalPaddingWide,
    };
    const calculateSizes = () => {
        if (carouselRef.current) {
            setCarouselDimension({
                clientWidth: carouselRef.current.clientWidth,
                scrollWidth: carouselRef.current.scrollWidth,
                scrollLeft: carouselRef.current.scrollLeft,
            });
        }
    };
    const isCarouselStart = carouselDimensions.scrollLeft === 0;
    const isCarouselEnd = carouselDimensions.clientWidth + Math.ceil(carouselDimensions.scrollLeft) >=
        carouselDimensions.scrollWidth;
    const onHandlePreviousClick = (event) => {
        if (carouselRef.current) {
            onPreviousClick && onPreviousClick(event);
            carouselRef.current.scrollBy({
                top: 0,
                left: customScrollWidth
                    ? -customScrollWidth
                    : -carouselDimensions.clientWidth,
                behavior: 'smooth',
            });
        }
    };
    const onHandleNextClick = (event) => {
        if (carouselRef.current) {
            onNextClick && onNextClick(event);
            carouselRef.current.scrollBy({
                top: 0,
                left: customScrollWidth || carouselDimensions.clientWidth,
                behavior: 'smooth',
            });
        }
    };
    const handleScroll = () => {
        calculateSizes();
    };
    React.useEffect(() => {
        calculateSizes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [size]);
    return (React.createElement(Styled.Container, null,
        React.createElement(Styled.Carousel, { "$hideScrollbar": hideScrollbar, "$horizontalPadding": horizontalPadding, "$horizontalPaddingConfined": horizontalPaddingConfined, "$horizontalPaddingWide": horizontalPaddingWide, "$paddingBottom": paddingBottom, "$paddingBottomConfined": paddingBottomConfined, "$paddingBottomWide": paddingBottomWide, "$paddingTop": paddingTop, "$paddingTopConfined": paddingTopConfined, "$paddingTopWide": paddingTopWide, "$verticalAlignment": verticalAlignment, className: className, "data-xds": "Carousel", onScroll: handleScroll, ref: carouselRef, tabIndex: 0, ...props }, React.Children.map(children, (item, index) => (React.createElement(Item, { itemIndex: index, key: index, tabbable: tabbable, onEnter: (direction, itemIndex) => onItemEnter && onItemEnter({ direction, itemIndex }), ...itemProps }, item)))),
        isCarouselStart ? null : (React.createElement(Styled.PreviousPageButton, { "$paddingBottom": paddingBottom || '0px', "$paddingBottomConfined": paddingBottomConfined || paddingBottom, "$paddingBottomWide": paddingBottomWide || paddingBottom, "$paddingTop": paddingTop || '0px', "$paddingTopConfined": paddingTopConfined || paddingTop, "$paddingTopWide": paddingTopWide || paddingTop, "aria-label": "Previous Page", icon: IconArrowLeft, onClick: onHandlePreviousClick, size: "medium", variant: "tertiary" })),
        isCarouselEnd ? null : (React.createElement(Styled.NextPageButton, { "$paddingBottom": paddingBottom || '0px', "$paddingBottomConfined": paddingBottomConfined || paddingBottom, "$paddingBottomWide": paddingBottomWide || paddingBottom, "$paddingTop": paddingTop || '0px', "$paddingTopConfined": paddingTopConfined || paddingTop, "$paddingTopWide": paddingTopWide || paddingTop, "aria-label": "Next Page", icon: IconArrowRight, onClick: onHandleNextClick, size: "medium", variant: "tertiary" }))));
};
Carousel.displayName = 'Carousel';
//# sourceMappingURL=carousel.js.map